module.exports = __webpack_public_path__ + "1aab52dc0f6d1eb522af872ee0ed1710.svg";